import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import SelectField from "../../../components/SelectField";

export default function BeneficiarStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <SelectField
        label="Tip beneficiar"
        value={data.beneficiarTip}
        onChange={update("beneficiarTip")}
        options={[
          { value: "pf", label: "Persoana fizica" },
          { value: "pfa", label: "PFA (Persoana Fizica Autorizata)" },
          { value: "srl", label: "SRL (Societate cu Raspundere Limitata)" },
        ]}
      />

      {data.beneficiarTip === "pf" && (
        <>
          <InputField label="Nume complet" value={data.beneficiarNume} onChange={update("beneficiarNume")} placeholder="ex: Ionescu Maria" required error={errors.beneficiarNume} />
          <InputField label="Adresa de domiciliu" value={data.beneficiarAdresa} onChange={update("beneficiarAdresa")} placeholder="ex: Str. Exemplu nr. 2, Bucuresti" required error={errors.beneficiarAdresa} />
          <OptionalFields>
            <InputField label="CNP" value={data.beneficiarCNP} onChange={update("beneficiarCNP")} placeholder="ex: 1234567890123" half error={errors.beneficiarCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI" value={data.beneficiarCI} onChange={update("beneficiarCI")} placeholder="ex: MZ 654321" half error={errors.beneficiarCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
        </>
      )}

      {data.beneficiarTip === "pfa" && (
        <>
          <InputField label="Denumire PFA" value={data.beneficiarDenumire} onChange={update("beneficiarDenumire")} placeholder="ex: Ionescu Maria PFA" required error={errors.beneficiarDenumire} />
          <InputField label="CUI" value={data.beneficiarCUI} onChange={update("beneficiarCUI")} placeholder="ex: 12345678" required half error={errors.beneficiarCUI} />
          <InputField label="Sediu profesional" value={data.beneficiarSediu} onChange={update("beneficiarSediu")} placeholder="ex: Str. Exemplu nr. 2, Bucuresti" required error={errors.beneficiarSediu} />
          <InputField label="Reprezentant" value={data.beneficiarReprezentant} onChange={update("beneficiarReprezentant")} placeholder="ex: Ionescu Maria" required half error={errors.beneficiarReprezentant} />
        </>
      )}

      {data.beneficiarTip === "srl" && (
        <>
          <InputField label="Denumire societate" value={data.beneficiarDenumire} onChange={update("beneficiarDenumire")} placeholder="ex: SC Exemplu SRL" required error={errors.beneficiarDenumire} />
          <InputField label="CUI" value={data.beneficiarCUI} onChange={update("beneficiarCUI")} placeholder="ex: RO12345678" required half error={errors.beneficiarCUI} />
          <InputField label="Nr. Reg. Comertului" value={data.beneficiarRegCom} onChange={update("beneficiarRegCom")} placeholder="ex: J40/5678/2020" half />
          <InputField label="Sediu social" value={data.beneficiarSediu} onChange={update("beneficiarSediu")} placeholder="ex: Str. Exemplu nr. 2, Bucuresti" required error={errors.beneficiarSediu} />
          <InputField label="Reprezentant legal" value={data.beneficiarReprezentant} onChange={update("beneficiarReprezentant")} placeholder="ex: Ionescu Maria" required error={errors.beneficiarReprezentant} />
        </>
      )}
    </div>
  );
}
